import React, { useRef } from "react";
import LandingBackgroundFX from "@/components/LandingBackgroundFX";
import { LP_CSS, LOGO } from "@/pages/LandingPage";
import { toast } from "sonner";

// TODO(Alê): troca esse link quando o APK/link da Play Store estiver pronto.
// Enquanto for "#", o botão só mostra um aviso de "em breve" em vez de navegar.
const ANDROID_APP_LINK = "";

export default function AndroidDownloadPage() {
  const mockupRef = useRef(null);

  const handleDownload = (e) => {
    if (!ANDROID_APP_LINK) {
      e.preventDefault();
      toast.info("O app tá quase pronto! Volta aqui em breve pra baixar 🚀");
    }
  };

  return (
    <div className="lp-root">
      <style>{LP_CSS}</style>
      <style>{`
        .and-hero { position:relative; z-index:10; max-width:640px; margin:0 auto; padding:8rem 6% 5rem; text-align:center; display:flex; flex-direction:column; align-items:center; }
        .and-logo { height:52px; margin-bottom:2.2rem; }
        .and-badge { display:inline-flex; align-items:center; gap:8px; padding:.5rem 1.1rem; border-radius:100px; background:rgba(34,197,94,0.12); border:1px solid rgba(34,197,94,0.35); font-size:.78rem; font-weight:700; letter-spacing:.5px; text-transform:uppercase; color:#86efac; margin-bottom:1.8rem; }
        .and-hero h1 { font-size:clamp(2rem,6vw,2.9rem); line-height:1.15; font-weight:800; letter-spacing:-.03em; margin:0 0 1.3rem; }
        .and-hero p { font-size:1.05rem; line-height:1.65; color:var(--lp-muted); margin:0 auto 2.6rem; max-width:480px; }
        .and-phone-mock { width:220px; height:220px; border-radius:50px; background:linear-gradient(145deg,#18181b,#000); border:6px solid #27272a; display:flex; align-items:center; justify-content:center; margin-bottom:2.6rem; box-shadow:0 30px 70px rgba(0,0,0,0.55); position:relative; }
        .and-phone-mock::before { content:""; position:absolute; top:14px; left:50%; transform:translateX(-50%); width:50px; height:5px; border-radius:4px; background:#3f3f46; }
        .and-phone-mock img { width:64px; height:64px; border-radius:16px; }
        .and-btn { background:linear-gradient(120deg,#22c55e,#16a34a); color:#fff; border:none; padding:1rem 2.4rem; border-radius:100px; font-weight:700; font-size:1rem; cursor:pointer; display:inline-flex; align-items:center; gap:10px; text-decoration:none; box-shadow:0 10px 30px rgba(34,197,94,.4); transition:transform .25s ease, box-shadow .25s ease; }
        .and-btn:hover { transform:translateY(-2px); box-shadow:0 14px 36px rgba(34,197,94,.55); }
        .and-foot { margin-top:2rem; font-size:.82rem; color:var(--lp-muted); }
        .and-features { position:relative; z-index:10; max-width:560px; margin:0 auto 5rem; padding:0 6%; display:grid; gap:.9rem; }
        .and-feature { display:flex; align-items:center; gap:12px; background:var(--lp-glass); border:1px solid var(--lp-border); border-radius:16px; padding:1rem 1.2rem; backdrop-filter:blur(10px); font-size:.92rem; color:var(--lp-text); }
        .and-feature .dot { width:34px; height:34px; border-radius:10px; background:rgba(34,197,94,.14); border:1px solid rgba(34,197,94,.3); display:grid; place-items:center; flex-shrink:0; font-size:1.05rem; }
      `}</style>

      <LandingBackgroundFX chipData={[]} mockupRef={mockupRef}>

        <section className="and-hero">
          <img src={LOGO} alt="AutoPostBR" className="and-logo" />

          <div className="and-badge"> App Android chegando</div>

          <div className="and-phone-mock">
            <img src={LOGO} alt="" />
          </div>

          <h1>O AutoPostBR agora vive no seu bolso.</h1>
          <p>
            Tudo que você já faz no site — prospecção, WhatsApp, pipeline de vendas, propostas —
            no app Android, sempre à mão. Baixe pra continuar usando pelo celular.
          </p>

          <a className="and-btn" href={ANDROID_APP_LINK || "#"} onClick={handleDownload}>
             Baixar o app Android
          </a>
          <p className="and-foot">Já usa iPhone? O site funciona normalmente no Safari — sem precisar de app.</p>
        </section>

        <div className="and-features">
          <div className="and-feature"><span className="dot">💬</span> WhatsApp automatizado, do jeito que você já usa</div>
          <div className="and-feature"><span className="dot">🗂️</span> Pipeline de vendas e equipe, direto do celular</div>
          <div className="and-feature"><span className="dot">🔔</span> Notificações na hora, sem precisar abrir o navegador</div>
        </div>

      </LandingBackgroundFX>
    </div>
  );
}
